import { Children, cloneElement } from "react";
function isLink(node) {
  return typeof node !== "string" && !!node.props.href;
}
function removeLinks(node) {
  if (typeof node === "string") {
    return node;
  }
  return Children.map(node, (child) => {
    if (isLink(child)) {
      child = child.props.children;
    }
    if (typeof child === "string") {
      return child;
    }
    if (Array.isArray(child)) {
      return removeLinks(child);
    }
    const children = removeLinks(child.props.children);
    return cloneElement(child, { children });
  });
}
export {
  removeLinks
};
